/**
 * Video.js options.
 *
 * Video options are shared by video-player.js and video-modal.js.
 */
module.exports = {
    'controls': true,
    'autoplay': false,
    'preload': 'metadata',
    'fluid': true,
    'flash': {
        'swf': '/vendor/videojs/video-js.swf'
    }
};
